import { EnrichedWorkflowComponent, WorkflowNodeParameter } from '../../types'
import { WorkflowComponent, WorkflowComponentParamType } from '@cloud-native/workflows-engine'
import { isNil } from '../../../common/utils/isNil'
import { FeatureFlag, selectActualFeatureFlags } from '../../../../app/ui/useFeatureFlag'
import { getStore } from '../../../../app/state/storeRegistry'
import settings from '../../../../settings'

export function populateInputDefaults(inputs: WorkflowNodeParameter[]): WorkflowComponent['inputs'] {
  return inputs.map((input) => {
    if (
      input.type === WorkflowComponentParamType.Selection &&
      ((input.options as unknown[]) || []).length &&
      input.value === undefined &&
      !input.optional
    ) {
      return { ...input, value: (input.options as unknown[])[0] as string }
    }

    if (input.type === WorkflowComponentParamType.Number && input.value === undefined) {
      const { max, min } = input

      if (
        input.default === undefined &&
        !input.optional &&
        !isNil(max) &&
        !isNil(min) &&
        Number.isFinite(min) &&
        Number.isFinite(max)
      ) {
        // if max and min are defined we set the value in the middle
        return { ...input, value: Math.floor(((max as number) - (min as number)) / 2) }
      } else if (!input.optional) {
        return { ...input, value: input.default === undefined ? 0 : input.default }
      }
    }

    if (input.value === undefined && input.default !== undefined && input.default !== null) {
      return { ...input, value: input.default as string }
    }

    return input
  }) as unknown as WorkflowComponent['inputs']
}

export const filterComponents = (components: Record<string, EnrichedWorkflowComponent>): Array<WorkflowComponent> => {
  const featureFlags = selectActualFeatureFlags(getStore().getState())

  return (
    Object.values(components)
      // hide 'Send by email' if exports are globally disabled
      // hide 'Output' if FF workflowsExport2 is disabled
      .filter(
        (component) =>
          !component.metadata.deprecated &&
          (settings.enableExports || component.metadata.name !== 'SaveToBucketAndNotify') &&
          (featureFlags[FeatureFlag.WorkflowsExport2] || component.metadata.name !== 'native.output')
      )
  )
}
